import {cloneDeep, first} from 'lodash';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

import * as moment from 'moment';
import {UserService} from '../../service/user.service';
import {LivelihoodInformationService} from '../../service/livelihood-information.service';
import {EmployeeType} from '../../model/employee-type.model';
import {ManualCreditAssessment} from '../../model/manual-credit-assessment.model';
import {CreditAssessmentService} from '../../service/credit-assessment.service';
import {LivelihoodInformation} from '../../model/livelihood-information.model';
import {LoanApplicationService} from '../../service/loan-application.service';
import {LoanApplication} from '../../model/loan-application.model';
import {UserAddressService} from '../../service/user-address.service';
import {UserAddress} from '../../model/user-address.model';
import { LoanStatus } from '../../model/loan-status.model';
import { LoanSuggestedTermService } from '../../service/rbi-compliance/loan-suggested-term.service';
import { Keys, StorageService } from '../../service/storage.service';
import { LoanSuggestedTermPopUpComponent } from '../../shared/loan-suggested-term-pop-up/loan-suggested-term-pop-up.component';
import { LOAN_SUGGESTED_TERM, LoanSuggestedTerm, UserSuggestedTerm } from '../../model/rbi-compliance/loan-suggested-term.model';
import { Toaster, Type } from '../../toaster/Toaster';
import { WithdrawnSuccessPopUpComponent } from '../../shared/withdrawn-success-pop-up/withdrawn-success-pop-up.component';
import { LoanDetailsService } from '../../service/loan-details.service';
import { LendersInvested } from '../../model/loan.model';

@Component({
    selector: 'app-manualinvestdetail',
    templateUrl: './manualinvestdetail.component.html',
    styleUrls: ['./manualinvestdetail.component.scss', '../../../assets/styles/finzy-styles.scss'],
    providers: [LivelihoodInformationService]
})
export class ManualinvestdetailComponent implements OnInit {

    age: number;
    experienceInYears: number;
    experienceInMonths: number;
    address: UserAddress;
    loanApplication: LoanApplication;
    livelihoodInformation: LivelihoodInformation;
    manualCreditAssessment: ManualCreditAssessment;
    EmployeeType = EmployeeType;
    shouldShowLoader = true;
    public loanSuggestedTerm: LoanSuggestedTerm;
    lenderInvested: LendersInvested;

    private readonly userService: UserService;
    private readonly userAddressService: UserAddressService;
    private readonly loanApplicationService: LoanApplicationService;
    private readonly creditAssessmentService: CreditAssessmentService;
    private readonly livelihoodInformationService: LivelihoodInformationService;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ManualinvestdetailComponent>,
        userService: UserService,
        livelihoodInformationService: LivelihoodInformationService,
        loanApplicationService: LoanApplicationService,
        creditAssessmentService: CreditAssessmentService,
        userAddressService: UserAddressService,
        private readonly loanSuggestedTermService: LoanSuggestedTermService,
        private readonly storageService: StorageService,
        private readonly loanDetailsService: LoanDetailsService,
        public dialog: MatDialog
    ) {
        this.userService = userService;
        this.livelihoodInformationService = livelihoodInformationService;
        this.loanApplicationService = loanApplicationService;
        this.creditAssessmentService = creditAssessmentService;
        this.userAddressService = userAddressService;
        this.data = cloneDeep(data);
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this.getUserData();
    }

    getAge(dob): number {
        const timeTillNow = moment().diff(moment(dob));
        return Math.floor(moment.duration(timeTillNow).asYears());
    }

    public investmentNegotiationHandler() {
        const loan: any = {
            loanId: this.data._id,
            loanShortId: this.loanApplication.shortId,
            loanAmount: this.data.loan_amount,
            tenure: this.loanApplication.tenure,
            finzyRating: this.data.rating,
            loanStatus: this.data.loan_sanction_status,
            investmentAmount: this.data.investmentAmount,
            borrowerId: this.data.profile._id,
            portfolioId: this.lenderInvested.portfolio_id
        };

        const borrowerDetail: any = {
            name: this.data.profile.name
        };

        this.dialogRef.close();
        const matDialogConfig: MatDialogConfig = {
            maxHeight: '90vh',
            width: '80%',
            panelClass: 'dialog-responsive',
            data: {
                loan: loan,
                borrowerDetail: borrowerDetail,
                loanSuggestedTerm: this.loanSuggestedTerm,
                isBorrower: false,
            }
        };
        this.dialog.open(LoanSuggestedTermPopUpComponent, matDialogConfig).afterClosed().subscribe((res) => {
            this.dialog.closeAll();
        });
    }

    public getLoanSuggestedTermByLoanIdAndLenderId() {
        const loanId = this.data._id;
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        this.loanSuggestedTermService.getLoanSuggestedTermByLoanIdAndLenderId(loanId, lenderId)
            .then((res) => {
                if (res[0]) {
                    this.loanSuggestedTerm = res[0];
                }
                this.getLenderInvestedInfo();
            })
            .catch((err) => {
                console.log(err);
            })
    }

    public getLenderInvestedInfo() {
        const loanId = this.data._id;
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        this.loanDetailsService.getLenderInvestedInfo(loanId, lenderId)
            .then((res) => {
                if (res[0]) {
                    this.lenderInvested = res[0].lenderInvested;
                } else {
                    const { portfolioId, lenderId, investedAmount } = this.loanSuggestedTerm.userSuggestedTerms[0];
                    this.lenderInvested = { portfolio_id: portfolioId, lender_id: lenderId, invested_amount: investedAmount, timestamp: null };
                }
                this.shouldShowLoader = false;
            })
            .catch((err) => {
                console.log(err);
            })
    }

    public isShowSuggestedLoanTermButton() {
        try {
            if (!(this.loanSuggestedTerm && this.loanSuggestedTerm?.userSuggestedTerms?.length) && (LoanStatus.hasToShowLoanSuggestedTerm(this.data.loan_sanction_status))) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    public investmentNegotiationWithdrawnHandler() {
        const userSuggestedTerm: UserSuggestedTerm = { ...this.loanSuggestedTerm.userSuggestedTerms[0], lenderStatus: LOAN_SUGGESTED_TERM.WITHDRAWN };
        const id = this.loanSuggestedTerm._id;
        this.loanSuggestedTermService.updateLoanSuggestedTerm(id, userSuggestedTerm)
            .then((res) => {
                this.dialog.closeAll();
                Toaster.toast('Updated Loan Terms Suggestion', Type.Success);
                this.dialog.open(WithdrawnSuccessPopUpComponent).afterClosed().subscribe((res) => { });
            })
            .catch((error) => {
                console.log('ERROR ', error);
            })
    }

    public isShowLoanSuggestedTerm(): boolean {
        if ((this.loanSuggestedTerm) && (this.loanSuggestedTerm.userSuggestedTerms) && (this.loanSuggestedTerm.userSuggestedTerms.length)) {
            if (first(this.loanSuggestedTerm.userSuggestedTerms).lenderStatus === LOAN_SUGGESTED_TERM.WITHDRAWN) {
                return false;
            }
            return true;
        }
        return false;
    }

    private async getUserData() {
        this.shouldShowLoader = true;

        if (typeof this.data.profile === 'string') {
            this.data.profile = await this.userService.getFilteredDetailsById(this.data.profile);
        }
        [, this.livelihoodInformation, this.manualCreditAssessment] = await Promise.all([
            this.populateLoanApplicationAndAddress(),
            this.livelihoodInformationService.getByLoanApplicationId(this.data.loanApplicationId),
            this.creditAssessmentService.getManualCreditAssessmentByLoanApplicationId(this.data.loanApplicationId)
        ]);
        this.experienceInYears = Math.floor(this.livelihoodInformation.totalExperienceMonths / 12);
        this.experienceInMonths = this.livelihoodInformation.totalExperienceMonths % 12;
        this.age = this.getAge(this.data.profile.dob);
        this.getLenderInvestedInfo();
        this.getLoanSuggestedTermByLoanIdAndLenderId();
    }

    private async populateLoanApplicationAndAddress() {
        this.loanApplication = await this.loanApplicationService.getLoanApplication(this.data.loanApplicationId);
        this.address = await this.userAddressService.get(this.loanApplication.addressId);
    }
}
